import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';

/**
 * The list of tabs on this page
 */
export enum DevoCommitmentsPageTabId {
	Commitments = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum DevoCommitmentsPageViewId {
	Commitments = 1,
}


@Injectable({ providedIn: 'root' })
export class DevoCommitmentsPageService extends PageTabsLayoutPageService<DevoCommitmentsPageTabId, DevoCommitmentsPageViewId> {
	private static readonly _viewDroplistItems: DroplistItem<never, DevoCommitmentsPageViewId>[] = [
		{
			uniqueId: DevoCommitmentsPageViewId.Commitments,
			iconContext: {
				iconClass: 'fa-grid',
				iconStyle: 'fa-solid',
				text: 'Commitments',
				hideText: 'never',
			}, customSort: '1-Commitments-2'
		},

	];
	constructor() {
		super(DevoCommitmentsPageService._viewDroplistItems, DevoCommitmentsPageService.name, DevoCommitmentsPageTabId.Commitments, DevoCommitmentsPageViewId.Commitments);
	}

	public get viewId() {
		return DevoCommitmentsPageViewId;
	}
}